/*
 * Tooltip: a short label on hover and focus. Never put essential information only in a tooltip.
 *   <Tooltip content="Copy"><button …/></Tooltip>
 * TooltipProvider is mounted once in the app providers.
 */
import { Tooltip as T } from 'radix-ui'
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export const TooltipProvider = T.Provider

export function Tooltip({
  content,
  children,
  side = 'top',
  className,
}: {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  className?: string
}) {
  if (!content) return <>{children}</>
  return (
    <T.Root>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          sideOffset={6}
          collisionPadding={8}
          className={cn(
            'z-[60] max-w-xs rounded-lg bg-ink-deep px-2.5 py-1.5 text-12 font-medium text-on-brand shadow-pop data-[state=closed]:animate-fade-out data-[state=delayed-open]:animate-fade-in',
            className,
          )}
        >
          {content}
        </T.Content>
      </T.Portal>
    </T.Root>
  )
}
